import { render, staticRenderFns } from "./ps-image-text.vue?vue&type=template&id=0305354f&"
import script from "./ps-image-text.js?vue&type=script&lang=js&"
export * from "./ps-image-text.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports